import { Component, OnInit } from '@angular/core';
import { MetricsService } from '../../shared/metrics.service';
import { EChartsOption } from 'echarts';

@Component({
    selector: 'app-availability',
    templateUrl: './availability.component.html',
    styleUrls: ['./availability.component.scss'],
    standalone: false
})
export class AvailabilityComponent implements OnInit {
  isLoading = true;
  hi;
  cpAvailabilityPct;
  cpNumDevices;

  fortinetsOption: EChartsOption;
  mistsOption: EChartsOption;
  cradlepointsOption: EChartsOption;

  fortinetAvailCurrentMonth;
  mistAvailCurrentMonth;
  cradlepointAvailCurrentMonth;

  fortinetAvgOfflineEventsPerDay;

  constructor(
    private metricsService: MetricsService
  ) {}

  getHi() {
    const promise = new Promise((resolve) => {
      this.metricsService.getMetricsHi().then(response => {
        response.toPromise().then(response => {
          try {
            // console.log(response)
            this.hi = response["message"].hi
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
  }

  getFortinetAvailabilityOrg() {
    const promise = new Promise((resolve) => {
      this.metricsService.getFortinetAvailabilityOrg().then(response => {
        response.toPromise().then(response => {
          try {
            let x_axis = [];
            let data = [];
            this.fortinetAvailCurrentMonth = response["message"].slice(-1)[0]["avail_pct"]
            response["message"].forEach(item => {
              x_axis.push(item["month_name"]);
              data.push(item["avail_pct"]);
            });

            this.fortinetsOption = {
              xAxis: {
                type: 'category',
                data: x_axis,
              },
              yAxis: {
                type: 'value',
                scale: true,
                max: 100,
                name: 'Total Online / Total Time',
                nameLocation: 'middle',
                nameGap: 70
              },
              series: [
                {
                  data: data,
                  type: 'line',
                },
              ],
              tooltip: {
                show: true
              }
            };

          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    return promise
  }

  getFortinetAvgOfflineEventsPerDay() {
    const promise = new Promise((resolve) => {
      this.metricsService.getFortinetAvgOfflineEventsPerDay().then(response => {
        response.toPromise().then(response => {
          try {
            // console.log(response)
            this.fortinetAvgOfflineEventsPerDay = response["message"].slice(-1)[0]["avg_daily_offline_events"]
          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });  
  }

  getMistAvailabilityOrg() {
    const promise = new Promise((resolve) => {
      this.metricsService.getMistAvailabilityOrg().then(response => {
        response.toPromise().then(response => {
          try {
            let x_axis = [];
            let data = [];
            this.mistAvailCurrentMonth = response["message"].slice(-1)[0]["median_avail_chainwide"]
            response["message"].forEach(item => {
              x_axis.push(item["month_name"]);
              data.push(item["median_avail_chainwide"]);
            });

            this.mistsOption = {
              xAxis: {
                type: 'category',
                data: x_axis,
              },
              yAxis: {
                type: 'value',
                scale: true,
                max: 100,
                name: 'Median Across Stores',
                nameLocation: 'middle',
                nameGap: 70
              },
              series: [
                {
                  data: data,
                  type: 'line',
                },
              ],
              tooltip: {
                show: true
              }
            };

          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    return promise;
  }

  getCradlepointAvailabilityOrg() {
    const promise = new Promise((resolve) => {
      this.metricsService.getCradlepointAvailabilityOrg().then(response => {
        response.toPromise().then(response => {
          try {
            let x_axis = [];
            let data = [];
            this.cradlepointAvailCurrentMonth = response["message"].slice(-1)[0]["avail_pct"]
            response["message"].forEach(item => {
              x_axis.push(item["month_name"]);
              data.push(item["avail_pct"]);
            });

            this.cradlepointsOption = {
              xAxis: {
                type: 'category',
                data: x_axis,
              },
              yAxis: {
                type: 'value',
                scale: true,
                max: 100,
                name: 'Total Online / Total Time',
                nameLocation: 'middle',
                nameGap: 70
              },
              series: [
                {
                  data: data,
                  type: 'line',
                },
              ],
              tooltip: {
                show: true
              }
            };

          } catch (error) {
            console.log(error.message)
          } finally {
            resolve(true);
          }
        });
      });
    });
    return promise;
  }

  getFakeDelay() {
    const promise = new Promise((res) => {
      setTimeout(() => {
        console.log("timeout complete")
        res("p1")
      }, 3000)
    });
    return promise;
  }


  ngOnInit() {
    this.isLoading = true;
    Promise.all(
      [
        // console.log("hello!!"),
        // this.getHi(),
        this.getCradlepointAvailabilityOrg(),
        this.getFortinetAvailabilityOrg(),
        this.getMistAvailabilityOrg(),
        this.getFortinetAvgOfflineEventsPerDay()
        // this.getFakeDelay()

      ]
    ).then(() => {
        this.isLoading = false;
    }).catch(() => {
      console.log('Promise.all REJECTED');
      this.isLoading = false;
    });

  }


}
